"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const WaterfallByExcessMarginBalanceSheetStruct = zod_1.z.object({
    type: zod_1.z.literal('balanceSheet'),
    limitType: zod_1.z.enum(['min', 'max']),
    percentageRate: zod_1.z.number().optional(),
    value: zod_1.z.number().optional(),
});
const WaterfallByExcessMarginCreditFacilityStruct = zod_1.z.object({
    type: zod_1.z.literal('creditFacility'),
    creditFacilityId: zod_1.z.string(),
    limitType: zod_1.z.enum(['min', 'max']),
    percentageRate: zod_1.z.number().optional(),
    value: zod_1.z.number().optional(),
});
const WaterfallByExcessMarginConfigStruct = zod_1.z.discriminatedUnion('type', [
    WaterfallByExcessMarginBalanceSheetStruct,
    WaterfallByExcessMarginCreditFacilityStruct,
]);
//# sourceMappingURL=Assignment.js.map